import { useCallback, useEffect, useRef } from 'react';
import { useDocument } from '../hooks/useDocument.js';
export function useKeypressListener(code, handler, actionType = 'keyup') {
    const { document } = useDocument();
    const tracked = useRef({ handler, keyCode: code });
    useEffect(() => {
        tracked.current = { handler, keyCode: code };
    }, [handler, code]);
    const handleKeyEvent = useCallback((event) => {
        const { handler, keyCode } = tracked.current;
        if (event.code === keyCode) {
            handler(event);
        }
    }, []);
    useEffect(() => {
        document.addEventListener(actionType, handleKeyEvent);
        return () => {
            document.removeEventListener(actionType, handleKeyEvent);
        };
    }, [actionType, handleKeyEvent]);
    return null;
}
//# sourceMappingURL=useKeypressListener.js.map